import React, { useMemo } from 'react';

import { Spinner, T8y } from 'ui';

import style from './informMsgSection.module.scss';

export const InformMsgSection = ({
  selectingDetails,
  postcodeError,
  isPostcodeValidating,
  isMobile,
}) => {
  const message = useMemo(() => {
    if (postcodeError) {
      return { color: 'darkDanger', text: postcodeError };
    }

    if (isMobile) {
      return '';
    }

    if (selectingDetails.postcode) {
      return typeof selectingDetails.permit === 'string'
        ? {
            color: 'success',
            text: 'Click “Book now“ to proceed with online checkout',
          }
        : {
            color: 'success',
            text: 'Choose a Permit option and click “Book now“ to proceed with online checkout',
          };
    }
    return {
      color: 'wilkoOrange',
      text: 'Pricing and availability is subject to your location.\nPlease enter your postcode for an accurate price.',
    };
  }, [
    isMobile,
    postcodeError,
    selectingDetails.permit,
    selectingDetails.postcode,
  ]);

  if (isPostcodeValidating) {
    return (
      <T8y variant="t2v1" color={message.color} className={style.informMessage}>
        <Spinner size={2} className={style.informMessageLoading} />
      </T8y>
    );
  }

  return (
    <T8y variant="t2v1" color={message.color} className={style.informMessage}>
      {message.text ===
      "Sorry, we're unable to fetch pricing for this product at the moment." ? (
        <span className={style.informMessageNoPostcodeText}>
          Sorry, we're unable to fetch pricing for this product at the moment.
        </span>
      ) : (
        message.text
      )}
    </T8y>
  );
};
